import { CustomSection } from "./CustomSection";
import { CustomField } from "./customfield";

export class CustomFieldConfig {
    accountId: number;
    customFields: CustomField[];
    sections: CustomSection[] = [];
}